import { render, staticRenderFns } from "./remark.vue?vue&type=template&id=f6a0fcc8&scoped=true"
import script from "./_remark.js?vue&type=script&lang=js&external"
export * from "./_remark.js?vue&type=script&lang=js&external"
import style0 from "./_remark.scss?vue&type=style&index=0&id=f6a0fcc8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a0fcc8",
  null
  
)

export default component.exports